import VueI18n from 'vue-i18n'

//i18n filter比較特別，需要注入vueI18n實例
export function ParaDisplay($i18n: VueI18n) {
	return (value: any, paramesters: Array<any>) => {
		if (!Array.isArray(paramesters)) {
			return value
		}

		let result = paramesters.find(parameter => parameter.PhsiName == value)
		if (!result) {
			return value
		}
		if ($i18n.locale === 'en' && result.DispNameInEnglish) {
			return result.DispNameInEnglish
		}
		return result.DispName
	}
}

export function I18nColumn($i18n: VueI18n) {
	return (data: any, columnName: string) => {
		if (!data) {
			return data
		}

		if ($i18n.locale === 'en' && data[columnName + 'InEnglish']) {
			return data[columnName + 'InEnglish']
		}
		return data[columnName]
	}
}

export function DateTime($i18n: VueI18n) {
	return (value: any, type: string = 'short') => {
		if (!value) {
			return value
		}
		try {
			let date = new Date(value)
			return $i18n.d(date, type)
		} catch (err) {
			return value
		}
	}
}
